jQuery(function ($) {
	const base = "gc-faq";

	$(`.${base}__question`).on("click", function () {
		$(`.${base}__question-wrapper--active`).removeClass(`${base}__question-wrapper--active`);
		$(this).parent().toggleClass(`${base}__question-wrapper--active`);
	});
});
